
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
  import { calculatePosition } from '../utils/helpers'

@Component
  export default class TourPopover extends Vue {
  @Prop({ type: Boolean, default: false }) active!: boolean;
  @Prop({ type: String, default: '' }) targetSelector!: string;
  @Prop({ type: String, default: 'bottom' }) placement!: 'top' | 'right' | 'bottom' | 'left' | 'center';
  @Prop({ type: Object, default: () => ({ x: 0, y: 0 }) }) offset!: { x: number; y: number };
  @Prop({ type: String, default: '' }) title!: string;
  @Prop({ type: String, default: '' }) content!: string;
  @Prop({ type: Number, default: 1 }) currentStep!: number;
  @Prop({ type: Number, default: 1 }) totalSteps!: number;
  @Prop({ type: Number, default: 0 }) progress!: number;
  @Prop({ type: Boolean, default: true }) showButtons!: boolean;
  @Prop({ type: Boolean, default: true }) showProgress!: boolean;
  @Prop({ type: Boolean, default: true }) showCloseButton!: boolean;
  @Prop({ type: Boolean, default: false }) darkMode!: boolean;
  @Prop({ type: Boolean, default: false }) isLastStep!: boolean;

  // Elemento objetivo calculado
  targetElement: HTMLElement | null = null;

  // Estilos para el popover
  popoverStyle = {
    top: '0px',
    left: '0px',
  };

  @Watch('targetSelector')
  @Watch('active')
  @Watch('placement')
  @Watch('offset')
  updateTargetElement () {
    if (this.active) {
      this.$nextTick(() => {
        this.targetElement = document.querySelector(this.targetSelector)
        this.updatePopoverPosition()
      })
    } else {
      this.targetElement = null
    }
  }

  mounted () {
    this.updateTargetElement()
    window.addEventListener('resize', this.updatePopoverPosition)
    window.addEventListener('scroll', this.updatePopoverPosition)
  }

  beforeDestroy () {
    window.removeEventListener('resize', this.updatePopoverPosition)
    window.removeEventListener('scroll', this.updatePopoverPosition)
  }

  /**
   * Actualiza la posición del popover según la posición del elemento
   */
  updatePopoverPosition () {
    if (!this.targetElement || !this.$refs.popover) return

    const popoverElement = this.$refs.popover as HTMLElement
    const position = calculatePosition(
      this.targetElement,
      popoverElement,
      this.placement,
      this.offset
    )

    this.popoverStyle = {
      top: `${position.top}px`,
      left: `${position.left}px`,
    }
  }
  }
